import '@celo-tools/use-contractkit/lib/styles.css'

import { useMutation } from '@apollo/client'
import { useContractKit } from '@celo-tools/use-contractkit'
import React, { useCallback, useMemo } from 'react'

import { Notify } from '../../lib/helpers'
import { CryptoDataProviders } from '../../models'
import { Button } from '..'
import { MUTATION, UpdatePayableAddress } from './queries'

export function AddMetamask({
    type = 'header',
    saveOnAccount = false,
    onActiveText = '',
    text = null,
    className = '',
    onConnect = () => {},
    onActiveClick = () => {},
    disabled = false,
}: {
    type?: 'button' | 'header' | 'white'
    onActiveText?: string
    saveOnAccount?: boolean
    text?: string | null
    className?: string
    onConnect?: () => void
    onActiveClick?: () => void
    disabled?: boolean
}) {
    const { connect, address } = useContractKit()

    const handleConnect = useCallback(async () => {
        try {
            await connect()
        } catch (e) {
            console.error(e)
        }
    }, [connect])

    const payableAddress = useMemo(() => {
        if (!address) return address

        const shortAddress =
            address?.substring(0, 2) +
            '...' +
            address?.substring(address?.length - 5)

        return shortAddress
    }, [address])

    const [saveCredential] = useMutation(MUTATION, {
        onError: error => {
            Notify('danger', 'Whoopsies', error.message)
        },
        onCompleted: data => {
            Notify('success', 'Yippee!', `Your Metamask account has been saved`)
            onConnect()
        },
    })
    const [savePayableAddress] = useMutation(UpdatePayableAddress, {
        onError: error => {
            Notify('danger', 'Whoopsies', error.message)
        },
        onCompleted: data => {
            Notify('success', 'Yippee!', `Your Metamask account has been saved`)
            onConnect()
        },
    })
    const ethereum = (window as any).ethereum
    const metamsakInstalled = ethereum && ethereum.isMetaMask

    const saveAccount = async (address: string) => {
        if (address) {
            const body = {
                variables: {
                    input: {
                        provider: CryptoDataProviders.MASA,
                        institution: 'metamask',
                        address,
                    },
                },
            }

            if (saveOnAccount) {
                savePayableAddress({
                    variables: { input: { payableAddress: address } },
                })
            } else {
                await saveCredential(body)
            }
        }
    }

    const HeaderButton = () => (
        <div
            className='mt-2 text-sm font-medium leading-4 cursor-pointer text-linkYellow'
            onClick={async () => {
                return handleConnect()
            }}>
            {payableAddress
                ? `Connected to ${payableAddress}`
                : 'Connect wallet'}
        </div>
    )

    const MetamaskButton = () => (
        <Button
            className={`cursor-pointer ${
                className ? '' : 'lg:w-full w-max'
            }  mt-12 lg:mt-0 px-32 ${className}`}
            onClick={async () => {
                if (payableAddress) {
                    const permissions: any[] = await ethereum.request({
                        method: 'wallet_requestPermissions',
                        params: [
                            {
                                eth_accounts: {},
                            },
                        ],
                    })

                    if (permissions.length) {
                        return saveAccount(
                            permissions?.[0]?.caveats?.[1]?.value[0],
                        )
                    }
                }
                const accounts: string[] = await ethereum.request({
                    method: 'eth_requestAccounts',
                })
                saveAccount(accounts[0])
            }}>
            {'Connect wallet'}
        </Button>
    )

    const MetamaskWhiteButton = () => (
        <Button
            disabled={disabled}
            minimal
            className='text-black bg-white border border-black cursor-pointer hover:bg-black hover:text-white'
            onClick={async () => {
                if (payableAddress) {
                    onActiveClick()
                } else {
                    return handleConnect()
                }
            }}>
            {payableAddress ? onActiveText : 'Connect wallet'}
        </Button>
    )
    return (
        <>
            {metamsakInstalled ? (
                type === 'button' ? (
                    <MetamaskButton />
                ) : type === 'header' ? (
                    <HeaderButton />
                ) : (
                    <MetamaskWhiteButton />
                )
            ) : (
                <div
                    className='mt-2 text-sm font-medium leading-4 cursor-pointer text-linkYellow'
                    onClick={async () => {
                        Notify('warning', 'Warning', `Please install Metamask`)
                    }}>
                    Install Metamask before linking your account
                </div>
            )}
        </>
    )
}
